import {
	Component,
	OnInit,
	OnChanges,
	Input,
	Output,
	EventEmitter,
	NgZone,
	ChangeDetectorRef,
	Renderer2,
	SimpleChanges,
} from '@angular/core';
import { Subscription } from 'rx';
import { fromEvent } from 'rxjs';
import { auditTime } from 'rxjs/operators';
import { UtilsService } from '../../services/utils.service';

@Component({
	selector: 'modal-header-new',
	template: require('./modal-header-new.component.html'),
})
export class ModalHeaderNewComponent implements OnInit, OnChanges {
	@Input() title: string;
	@Input() isFlagActive: boolean;
	@Input() isFirstStep: boolean;
	@Input() hasStepper: boolean = true;
	@Input() textColor: string = 'text-primary';
	@Input() bgColor: string = 'bg-white';
	@Input() hasCloseButton: boolean = true;
	@Input() stepperClass: string = 'modal-stepper-header-container';
	@Input() headerClass: string = 'modal-header-new-container';
	@Output() emitCloseModal = new EventEmitter();
	@Output() emitMoveBackStep = new EventEmitter();
	@Output() emitToggleFlag = new EventEmitter();
	@Input() scrollOffset: number = 1024;
	@Input() focusSet: number = 0;

	hasFlag: boolean;
	scrollSubscription: Subscription;
	audit$ = fromEvent(document, 'scroll').pipe(auditTime(250));
	constructor(
		private ngzone: NgZone,
		private cdref: ChangeDetectorRef,
		private utilsService: UtilsService,
		private renderer: Renderer2
	) {}

	closeModal(): void {
		this.emitCloseModal.emit();
	}

	moveBackStep(): void {
		this.emitMoveBackStep.emit();
	}

	toggleFlag() {
		this.isFlagActive = !this.isFlagActive;
		this.emitToggleFlag.emit();
	}

	ngOnInit() {
		if (this.isFlagActive === undefined) {
			this.hasFlag = false;
		} else {
			this.hasFlag = true;
		}
	}
	ngOnChanges(changes: SimpleChanges) {
		for (const propName in changes) {
			if (changes.hasOwnProperty(propName)) {
				switch (propName) {
					case 'focusSet': {
						document.getElementById('closeButton').focus();
					}
				}
			}
		}
	}
}
